function Comment({ comment }) {
    return (
      <div className={'mainContainer'}>
          <div className={'header'}>
              <div className={'headerBorderBefore'}></div>                
              <div className={'headerTitle'}>
                  <span className={'title'}>Comment</span>
              </div>
              <div className={'headerBorderAfter'}></div>
          </div>
          <div className={'childrenContainer'}>
            {comment}
          </div>
      </div>
    );
}

export default Comment;